var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import 'draft-js/dist/Draft.css';
import { Button } from 'reactstrap';
import { T } from '../helpers/i18n';
import { copyToClipboard } from '../helpers/Utils';
import { inject } from 'mobx-react';
var customStyleMap = {
    'LINEHEIGHT-1': { lineHeight: '1' },
    'LINEHEIGHT-1.5': { lineHeight: '1.5' },
    'LINEHEIGHT-2': { lineHeight: '2' },
};
var EditorConvertToHTML = /** @class */ (function (_super) {
    __extends(EditorConvertToHTML, _super);
    function EditorConvertToHTML(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            editorState: EditorState.createEmpty(),
        };
        _this.onEditorStateChange = function (editorState) {
            _this.setState({
                editorState: editorState,
            });
            if (_this.props.onEditorChange) {
                var raw = convertToRaw(editorState.getCurrentContent());
                var html = draftToHtml(raw);
                _this.props.onEditorChange(html, _this.props.language);
            }
        };
        // console.log('contentHtml: ', props.contentHtml)
        var contentBlocks = htmlToDraft(props.contentHtml || '<p></p>').contentBlocks;
        var contentState = ContentState.createFromBlockArray(contentBlocks);
        _this.state = {
            editorState: EditorState.createWithContent(contentState),
        };
        return _this;
    }
    EditorConvertToHTML.prototype.render = function () {
        var _this = this;
        var editorState = this.state.editorState;
        return (React.createElement("div", null,
            React.createElement(Editor, { editorState: editorState, wrapperClassName: "demo-wrapper", editorClassName: "demo-editor", onEditorStateChange: this.onEditorStateChange, customStyleMap: customStyleMap }),
            React.createElement(Button, { onClick: function () {
                    console.log('copiando');
                    var raw = convertToRaw(editorState.getCurrentContent());
                    var html = draftToHtml(raw);
                    copyToClipboard(html, 'text/html').then(function (value) {
                        _this.props.store.UI.newWarning('copiedToClipboard');
                    })
                        .catch(function (reason) {
                        _this.props.store.UI.newError('noCopiedClipboard');
                    });
                    // @ts-ignore
                    /*navigator.clipboard.read().then(value => {
                      console.log('window.clipboard.read()', value)
                      value.forEach(item => {
                        console.log('item: ', item)
                      })
                    })*/
                } }, T('copy')),
            this.props.editorStateCopied && React.createElement(Button, { onClick: function () {
                    _this.setState({ editorState: _this.props.editorStateCopied }, function () {
                        console.log('pegado');
                    });
                } }, T('paste'))));
    };
    EditorConvertToHTML = __decorate([
        inject('store')
    ], EditorConvertToHTML);
    return EditorConvertToHTML;
}(Component));
export { EditorConvertToHTML };



//////////////////
// WEBPACK FOOTER
// ./src/components/EditorConverToHTML.tsx
// module id = 1404
// module chunks = 0